import { MenuItem, styled } from "@l2r-front/l2r-ui"

export const DropdownMenuItem = styled(MenuItem)(({ theme }) => ({
    display: "flex",
    justifyContent: "space-between",
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(1),
}))